import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrBeneficiaryCardComponent } from './components/fr-beneficiary-card/fr-beneficiary-card.component';
import { AvatarModule } from '../avatar/avatar.module';
import { SharedModule } from '../../shared/shared.module';
import { DonorModule } from '../donor/donor.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [FrBeneficiaryCardComponent],
  imports: [
    CommonModule,
    AvatarModule,
    SharedModule,
    DonorModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [FrBeneficiaryCardComponent]
})
export class FrBeneficiaryCardModule { }
